import { AlertCircle } from 'lucide-react';

export function FormError({ error }: { error: string | undefined }) {
  if (!error) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center gap-2 rounded bg-red-50 border border-red-200 p-3 text-red-700 text-sm animate-fade-in">
      <span className="flex items-center">
        <AlertCircle className="w-5 h-5 text-red-600" />
      </span>
      <p className="font-medium">{error}</p>
    </div>
  );
}
